import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/contact.vue')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import(/* webpackChunkName: "team" */ '../views/team.vue')
  },
  {
    path: '/consulting',
    name: 'consulting',
    component: () => import(/* webpackChunkName: "consulting" */ '../views/consulting.vue')
  },
  {
    path: '/corporate-development',
    name: 'corporate-development',
    component: () => import(/* webpackChunkName: "corporate-development" */ '../views/corporate-development.vue')
  },
  {
    path: '/advisors',
    name: 'advisors',
    component: () => import(/* webpackChunkName: "advisors" */ '../views/advisors.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import(/* webpackChunkName: "services" */ '../views/services.vue')
  },
  {
    path: '/methodology',
    name: 'methodology',
    component: () => import(/* webpackChunkName: "methodology" */ '../views/methodology.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  // More code ...

  next();
});

export default router
